import { render, staticRenderFns } from "./Flfg.vue?vue&type=template&id=397aba80&scoped=true&"
import script from "./Flfg.vue?vue&type=script&lang=js&"
export * from "./Flfg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397aba80",
  null
  
)

export default component.exports